import { toast } from "react-toastify";
import { callApi } from "../../config/apiCall";
import { Api, Saas_Api } from "../../config/apiEndPoints";
import { useNavigate } from "react-router-dom";
import { types } from "../constants/admintype";
import { call, put, takeLatest } from "redux-saga/effects";
import { API_BASE_URL } from "../../saas/Config/Api";

const userDetails = sessionStorage.getItem("userDetails")
  ? JSON.parse(sessionStorage.getItem("userDetails"))
  : {};

export function* getEmployeeAction(action) {
  try {
    const response = yield call(
      callApi,
      Saas_Api?.GET_EMPLOYEE,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_EMPLOYEEDATA_SUCCESS,
            payload: response?.data,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({ type: types.GET_EMPLOYEEDATA_FAILED, error: error.response });
  }
}

export function* watchGetEmployeedDataAction() {
  yield takeLatest(types.GET_EMPLOYEEDATA_REQUEST, getEmployeeAction);
}

export function* getEmployeeAttendanceAction(action) {
  try {

    const filters = action.payload
    const response = yield call(
      callApi,
      `${Saas_Api?.GET_ATTENDANCE}?month=${filters?.leaveMonth||""}&year=${filters?.leaveYear||""}&date=${filters?.leaveDate||""}&location=${filters?.officeLocation||""}&statusType=${filters?.statusType}`,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_EMPLOYEE_ATTENDANCE_SUCCESS,
            payload: response?.data,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_EMPLOYEE_ATTENDANCE_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetEmployeeAttendanceAction() {
  yield takeLatest(
    types.GET_EMPLOYEE_ATTENDANCE_REQUEST,
    getEmployeeAttendanceAction
  );
}

export function* getEmployeeLeaveWfhRequestAction(action) {
  try {
    const response = yield call(
      callApi,
      Saas_Api?.GET_ALL_LEAVE_WFH_REQUEST,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_EMPLOYEE_LEAVE_WFH_SUCCESS,
            payload: response?.data,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_EMPLOYEE_LEAVE_WFH_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetEmployeeLeaveWfhRequestAction() {
  yield takeLatest(
    types.GET_EMPLOYEE_LEAVE_WFH_REQUEST,
    getEmployeeLeaveWfhRequestAction
  );
}

export function* getAssetsAction(action) {
  try {
    const response = yield call(
      callApi,
      Saas_Api?.GET_STOCK,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_ASSETS_SUCCESS,
            payload: response?.data,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_ASSETS_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetAssetsAction() {
  yield takeLatest(types.GET_ASSETS_REQUEST, getAssetsAction);
}

export function* getManager(action) {
  try {
    const response = yield call(
      callApi,
      Saas_Api?.GET_ROPORTING_MANAGER,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_REPORTING_MANAGER_SUCCESS,
            payload: response?.data,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_REPORTING_MANAGER_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetManagerAction() {
  yield takeLatest(types.GET_REPORTING_MANAGER_REQUEST, getManager);
}

export function* getDepartment(action) {
  try {
    const response = yield call(
      callApi,
      Saas_Api?.GET_DEPARTMENT,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_DEPARTMENT_SUCCESS,
            payload: response?.data,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_DEPARTMENT_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetDeparrtmentAction() {
  yield takeLatest(types.GET_DEPARTMENT_REQUEST, getDepartment);
}

export function* getShiftt(action) {
  try {
    const response = yield call(
      callApi,
      Saas_Api?.GET_SHIFT,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_SHIFT_SUCCESS,
            payload: response?.data,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_SHIFT_FAILED,
      error: error,
    });
  }
}
export function* watchGetShiftAction() {
  yield takeLatest(types.GET_SHIFT_REQUEST, getShiftt);
}

export function* getLeave(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.GET_EMPLOYEE_LEAVE_DETAILS}?id=${action?.payload}`,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_LEAVE_SUCCESS,
            payload: response,
          });
        } else {
          toast.error(response?.data?.mssg);
          yield put({
            type: types.GET_LEAVE_SUCCESS,
            payload: response,
          });
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_LEAVE_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetLeaveAction() {
  yield takeLatest(types.GET_LEAVE_REQUEST, getLeave);
}

export function* getWfh(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.GETWFH_DATA}?employee_id=${action?.payload}`,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        yield put({
          type: types.GET_WFH_SUCCESS,
          payload: response?.data,
        });
        // if (response?.success) {

        // } else {
        //   toast.error(response?.data?.mssg, {
        //     position: "top-center",
        //     autoClose: 1500,
        //   });
        // }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_WFH_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetWfhAction() {
  yield takeLatest(types.GET_WFH_REQUEST, getWfh);
}

export function* getBranches(action) {
  try {
    const response = yield call(
      callApi,
      `policies/branches`,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    // //console.log("getBranchesData", response);

    if (response?.success) {
      yield put({
        type: types.GET_BRANCHES_SUCCESS,
        payload: response?.data,
      });
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_BRANCHES_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetBranchesAction() {
  yield takeLatest(types.GET_BRANCHES_REQUEST, getBranches);
}

export function* getAdminTickets(action) {
  try {
    const endpoint =  action?.payload?.path ?  action?.payload?.path :"tickets"
    const response = yield call(
      callApi,
      endpoint,
      "GET",
      null,
      userDetails?.token,
      API_BASE_URL
    );

    // console.log("ADMINTICKET", response ,action?.payload);

    if (response?.success) {
      yield put({
        type: types.GET_ADMINTICKET_SUCCESS,
        payload: response?.data,
      });
    } else {
      toast.error(response?.data?.mssg);
    }
  } catch (error) {
    yield put({
      type: types.GET_ADMINTICKET_FAILED,
      error: error.response,
    });
  }
}
export function* watchGetAdminTicketsAction() {
  yield takeLatest(types.GET_ADMINTICKET_REQUEST, getAdminTickets);
}
